
import u from "umbrellajs"
import Cookies from "plugins/cookies-js"
import { EventEmitter } from "events"

import DataRetriever from "app/data_retriever"

import { MapModes as MODES } from "./modes"
import track from "./track"


// from app/controllers/concerns/shared/controller_mixins/with_listing_search_page_map_or_list_mode.rb
const Cookie_key = "current_listing_search_page_map_or_list_mode"
/* eslint-disable no-unused-vars */
enum HTML_MAP_MODE_CLASS {
  ACTIVATED = "map-enabled",
  ALLOWED   = "map-allowed",
}
enum HTML_CARD_MODE_CLASS {
  ACTIVATED = "card-enabled",
}
/* eslint-enable no-unused-vars */
const $html = u("html")
const $body = u("body")


// region `load` options

interface LoadOptions {
  trigger_list_mode_data_load: boolean,
}
type InputLoadOptions = Partial<LoadOptions>
const DEFAULT_LOAD_OPTIONS: LoadOptions = {
  trigger_list_mode_data_load: true,
}

// endregion `load` options

// region `toListMode` options

interface ListModeOptions {
  trigger_data_load: boolean,
}
type InputListModeOptions = Partial<ListModeOptions>
const DEFAULT_LIST_MODE_OPTIONS: ListModeOptions = {
  trigger_data_load: true,
}

// endregion `toListMode` options


class MapModeClass extends EventEmitter {
  private readonly  default_option: MODES
  private           mode:           MODES

  constructor() {
    super()

    this.default_option = DataRetriever.hasClass(HTML_MAP_MODE_CLASS.ACTIVATED) ? MODES.card : MODES.list
    this.mode = this.default_option
  }

  public load(options: InputLoadOptions = {}){
    const merged_options: LoadOptions = Object.assign({}, DEFAULT_LOAD_OPTIONS, options)

    if ( DataRetriever.hasClass(HTML_MAP_MODE_CLASS.ALLOWED) ){
      if (this.getRememberedMode() === MODES.card){
        this.toCardMode()
      }
      else {
        this.toListMode({
          trigger_data_load: merged_options.trigger_list_mode_data_load,
        })
      }
    }
    else {
      this.toListMode({
        trigger_data_load: merged_options.trigger_list_mode_data_load,
      })
    }
  }
  public getShouldPersistChangedValue(){
    return DataRetriever.get("listing-search-page-map-or-list-mode-memory-enabled") || null
  }
  public getMapOrCardModeActivated(){
    return [MODES.map, MODES.card].includes(this.getCurrentMode())
  }
  public getListModeActivated(){
    return [MODES.list].includes(this.getCurrentMode())
  }
  public getCurrentMode(){
    return this.getRememberedMode()
  }
  public getRememberedMode(): MODES {
    if ( ! Cookies.enabled){
      return this.default_option
    }

    const value = Cookies.get(Cookie_key)
    if ( !Object.values(MODES).includes(value) ){
      return this.default_option
    }

    // Deprecated value transition
    if ( value === MODES.map ){ return MODES.card }

    return value as MODES
  }
  public toListMode(options: InputListModeOptions = {}){
    const merged_options: ListModeOptions = Object.assign({}, DEFAULT_LIST_MODE_OPTIONS, options);

    // `body` might also have class names set on server side
    // So need to handle it when removing
    [$html, $body].forEach((u_el) => {
      u_el.removeClass(HTML_MAP_MODE_CLASS.ACTIVATED)
      u_el.removeClass(HTML_CARD_MODE_CLASS.ACTIVATED)
    })
    this.setMode(MODES.list)
    if (merged_options.trigger_data_load) {
      this.emit("list_mode")
    }
    track.emit("list_mode")
    this.emit("mode_change")
  }
  public toCardMode(){
    [$html, $body].forEach((u_el) => {
      u_el.addClass(HTML_MAP_MODE_CLASS.ACTIVATED)
      u_el.addClass(HTML_CARD_MODE_CLASS.ACTIVATED)
    })
    this.setMode(MODES.card)
    this.emit("card_mode")
    track.emit("card_mode")
    this.emit("mode_change")

    // Fix/workaround visual bug when mode switched after scrolled-down in list mode
    window.scrollTo(0, 0)
  }
  public setMode(mode: MODES){
    if (! Cookies.enabled) { return }
    // Sometimes we want to disable it
    if (! this.getShouldPersistChangedValue()){ return }
    // Reject invalid value
    if (! Object.values(MODES).includes(mode)) { return }

    this.mode = mode
    Cookies.set(Cookie_key, mode, {
      // expire in 1 week
      expires: 7 * 24 * 60 * 60,
    })
  }
}


const MapModeSingleton = new MapModeClass()

export {
  MapModeSingleton,
}
export default MapModeSingleton
